import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { useTheme } from '../context/ThemeContext';
import logoImage from '../../images/logoMain.webp';
import './Header.css';

const Header = () => {
  const { currentLanguage, switchLanguage, t } = useLanguage();
  const { isDark, toggleTheme } = useTheme();
  const [menuOpen, setMenuOpen] = useState(false);

  const handleMenuToggle = () => setMenuOpen(!menuOpen);
  const closeMenu = () => setMenuOpen(false);

  return (
    <>
      <div
        className={`menu-overlay ${menuOpen ? 'visible' : ''} ${
          isDark ? 'dark-overlay' : 'light-overlay'
        }`}
        onClick={closeMenu}
      ></div>

      <header className="header smooth-enter">
        <nav className="navbar">
          <div className="logo fade-in-up">
            <Link to="/" className="logo-link" onClick={closeMenu}>
              <img src={logoImage} alt="Fan&Genz" className="logo-image" />
            </Link>
          </div>

          <button
            className={`menu-toggle ${menuOpen ? 'open' : ''}`}
            onClick={handleMenuToggle}
            aria-label="Toggle menu"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>

          <div
            className={`nav-center ${menuOpen ? 'active' : ''} ${
              isDark ? 'dark-bg' : 'light-bg'
            }`}
          >
            <ul className="nav-links elegant-fade">
              <li><Link to="/" onClick={closeMenu}>{t('home')}</Link></li>
              <li><Link to="/tours" onClick={closeMenu}>{t('tours')}</Link></li>
              <li><Link to="/about" onClick={closeMenu}>{t('about')}</Link></li>
              <li><Link to="/contact" onClick={closeMenu}>{t('contact')}</Link></li>
            </ul>
          </div>

          <div className="header-controls elegant-fade">
            <div className="language-switcher">
              <button
                className={`lang-btn ${currentLanguage === 'ka' ? 'active' : ''}`}
                onClick={() => switchLanguage('ka')}
              >
                GE
              </button>
              <button
                className={`lang-btn ${currentLanguage === 'en' ? 'active' : ''}`}
                onClick={() => switchLanguage('en')}
              >
                EN
              </button>
            </div>

            <button
              className={`theme-toggle ${isDark ? 'spin-glow' : 'spin-glow'}`}
              onClick={toggleTheme}
              aria-label="Toggle theme"
            >
              {isDark ? '☀️' : '🌙'}
            </button>
          </div>
        </nav>
      </header>
    </>
  );
};

export default Header;